import React from "react";
import { ShieldCheck } from "lucide-react";

export default function Logo({ size = "md", showText = true }) {
  const sizes = {
    sm: { box: "h-8 w-8", icon: 16, title: "text-sm", sub: "text-[10px]" },
    md: { box: "h-10 w-10", icon: 20, title: "text-base", sub: "text-[10px]" },
    lg: { box: "h-14 w-14", icon: 28, title: "text-xl", sub: "text-xs" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div className={`${s.box} rounded-md bg-[#E63946] flex items-center justify-center text-white shadow-lg shadow-red-900/30`}>
        <ShieldCheck size={s.icon} strokeWidth={2.4} />
      </div>
      {showText && (
        <div className="leading-tight">
          <div className={`${s.title} font-semibold tracking-tight text-slate-900`} style={{ fontFamily: "'Outfit', sans-serif" }}>
            CHIRIPAL
          </div>
          <div className={`${s.sub} uppercase tracking-[0.25em] text-[#475569]`}>
            Poly Films
          </div>
        </div>
      )}
    </div>
  );
}
